import { TipoProtocolloEnum } from "@app/shared/enum/tipo-protocollo-enum";
import { SettoreDTO } from "../settoreDTO";
import { DocumentoDTO } from "../documentoDTO";
import { ClassificaDTO } from "../classificaDTO";
import { UtenteDTO } from "../utenteDTO";
import { ClassificaVO } from "@app/shared/vo/classificaVO";
import { ClassificaGescorDTO } from "./classifica-gescorDTO";
import { StrutturaDTO } from "../strutturaDTO";
import { MetadatiProtocolloGescorDTO } from "./metadati-protocollo-gescorDTO";
import { DocumentoGescorDTO } from "./documeto-gescorDTO";
import { DestinatarioDTO } from "./destinatarioDTO";
import { DestinatarioInternoDTO } from "./destinatario-internoDTO";
import { DestinatarioDipendenteDTO } from "./destinatario-dipendenteDTO";
import { StatoPartenzaEnum } from "@app/shared/enum/stato-partenza.enum";
import { MetadatiProtocolloDTO } from "../metadati-protocolloDTO";

export class CorrispondenzaPartenzaDTO {

   id: string;

   idMittente: string;

   tipoProtocollo: TipoProtocolloEnum;

   mittente: SettoreDTO;

   oggetto: string;

   riservata: Boolean;

   primario: DocumentoGescorDTO;

   metadatiProtocollo: MetadatiProtocolloDTO;

   allegati: DocumentoGescorDTO[];

   destinatari: DestinatarioDTO[];

   destinatariCartacei: DestinatarioDTO[];

   destinatariInterni: DestinatarioInternoDTO[];

   destinatariDipendenti: DestinatarioDipendenteDTO[];

   classifica: ClassificaGescorDTO[] = new Array<ClassificaGescorDTO>();

   classificaInterna: ClassificaGescorDTO[] = new Array<ClassificaGescorDTO>();

   //   visibilitaPartenza: VisibilitaPartenzaDTO[];

   firmatario: UtenteDTO;

   operatore: UtenteDTO;

   numeroAllegati: number;

   descrizioneAllegati: string;

   stato: StatoPartenzaEnum;

   dataInserimento: string;

   //  datiFirma: DatiFirmaPartenzaDTO;

   //  statoPartenzaProtocollo: StatoPartenzaProtocolloDTO;

   //   richiesteAssociate: boolean;

   //   tipoRichieste: TipoRichiestaEnum[];

}